export enum MasterTypes {
  Unknown,
  Gender,
  Category,
  Curriculum,
  Stream,
  Classes,
  PaymentMethod,
  Credential,
  Batch,
  Documents,
  Holidays,
  Status, // Not used anymore
  Medium,
  Course,
  Subjects,
  Semester,
  Department,
  Role,
  FeesType,
  Counselor,
  Source,
  AssignTo,
  Reason,
  Platform,
  Reminder,
  Task,
  MailTemplates,
  Session,
  Room,
  Schema,
  Section,
  AssessmentCategory,
  GradeScale,
  FacultyMapWithDept,
  Rubric,
  SubjectTypes,
  MandatoryDocumentType,
  Notice,
  FacultyType,
  Shift,
  EmployeeReferral,
  ExamInstructionsTemplate,
  Notification
}
export const IndianState: any = [
  // { label: "None", value: 0 },
  { label: "Andaman and Nicobar Islands", value: 1 },
  { label: "Andhra Pradesh", value: 2 },
  { label: "Arunachal Pradesh", value: 3 },
  { label: "Assam", value: 4 },
  { label: "Bihar", value: 5 },
  { label: "Chandigarh", value: 6 },
  { label: "Chhattisgarh", value: 7 },
  { label: "Dadra and Nagar Haveli", value: 8 },
  { label: "Daman and Diu", value: 9 },
  { label: "Delhi", value: 10 },
  { label: "Goa", value: 11 },
  { label: "Gujarat", value: 12 },
  { label: "Haryana", value: 13 },
  { label: "Himachal Pradesh", value: 14 },
  { label: "Jammu and Kashmir", value: 15 },
  { label: "Jharkhand", value: 16 },
  { label: "Karnataka", value: 17 },
  { label: "Kerala", value: 18 },
  { label: "Lakshadweep", value: 19 },
  { label: "Madhya Pradesh", value: 20 },
  { label: "Maharashtra", value: 21 },
  { label: "Manipur", value: 22 },
  { label: "Meghalaya", value: 23 },
  { label: "Mizoram", value: 24 },
  { label: "Nagaland", value: 25 },
  { label: "Odisha", value: 26 },
  { label: "Puducherry", value: 27 },
  { label: "Punjab", value: 28 },
  { label: "Rajasthan", value: 29 },
  { label: "Sikkim", value: 30 },
  { label: "Tamil Nadu", value: 31 },
  { label: "Telangana", value: 32 },
  { label: "Tripura", value: 33 },
  { label: "Uttar Pradesh", value: 34 },
  { label: "Uttarakhand", value: 35 },
  { label: "West Bengal", value: 36 },
];

export enum ApprovalStatus {
  Rejected = 0,
  OptionalOut = 1,
  OnHold = 2,
  Enrolled = 3,
  InterestedOne = 4,
  All = 5,
}

export enum LanguageProficiency {
  Beginner = 0,
  Intermediate = 1,
  Advanced = 2,
}

export enum ResponseType {
  IdName,
  Complete,
  Filtered,
}

export enum CandidateRequestType {
  Undefine,
  Enquire,
  Student,
  Rejected,
  Walkins
}

export enum EnquiryType {
  Undefined,
  Website,
  Application,
}

// ProcessStepsEnum
export enum ProcessStepsEnum {
  Undefined = 0,
  Website = 1,
  New = 2,
  Counseling = 3,
  Registration = 4,
  Documents = 5,
  EmailInvoice = 6,
  Verification = 7,
  LSBU = 8,
  Enroll = 9,
}

export const ProcessStepsOptions = [
  { label: "New", value: ProcessStepsEnum.New },
  { label: "Counseling", value: ProcessStepsEnum.Counseling },
  { label: "Registration", value: ProcessStepsEnum.Registration },
  // { label: "Documents", value: 5 },
  { label: "Email Invoice", value: ProcessStepsEnum.EmailInvoice },
  // { label: "Verification", value: 7 },
  // { label: "LSBU", value: 8 },
  // { label: "Enroll", value: 9 },
];

// WebsiteSubSteps
export enum WebsiteSubSteps {
  SendForm,
  Received,
}

export enum NewSubSteps {
  Waiting = 0,
  Confirm = 1,
  Reject = 2,
  UndoReject = 3,
}

export enum CounselingSubSteps {
  Waiting = 0,
  Confirm = 1,
  Reject = 2,
  UndoReject = 3,
}

export enum RegistrationSubSteps {
  Waiting = 0,
  Proceed = 1, // Confirm
  Reject = 2,
  UndoReject = 3,
}

export enum DocumentsSubSteps {
  Submission = 0, // Waiting
  VerifyDocuments = 1, // Confirm
  Reject = 2,
  Acknowledgement = 3,
  UndoReject = 3,
}

export enum EmailInvoiceSubSteps {
  Waiting = 0,
  SendInvoice = 1, // Confirm
  Reject = 2,
  UndoReject = 3,
}

export enum VerificationSubSteps {
  Waiting = 0,
  VerifyDocuments = 1, // Confirm
  Reject = 2,
  Acknowledgement = 3,
  UndoReject = 4,
}

// LsbuSubSteps
export enum LsbuSubSteps {
  Waiting = 0,
  ReceivedCredentials = 1,
  Reject = 2,
  UndoReject = 3,
  ShareCVDocs = 4,
  ReceivedStudyContact = 5,
}

export enum CommonEnqListType {
  all = 1,
  newLead,
  unAssignedLead,
  activity,
  missedActivity,
}

export enum AttachmentsCategory {
  Undefined,
  Note,
  CallLog,
  Email,
  Meeting,
  Task,
  StudentDocuments,
  EmailInvoice,
  Lsbu,
}
export enum CommunicationType {
  Unknown,
  Note,
  CallLog,
  Mail,
  Meeting, // Correcting the typo from "Metting" to "Meeting"
  Task,
}

export enum AttachmentsInnerCategory {
  Undefined = 0,
  CV,
  StudyContact,
}

export const CategoryAttachmentName: any = {
  "0": "Undefined",
  "1": "Note",
  "2": "Call Log",
  "3": "Email",
  "4": "Meeting",
  "5": "Task",
  "6": "Student Documents",
  "7": "Email Invoice",
  "8": "LSBU",
};

export enum MeetingType {
  Undefined,
  Online,
  Offline,
}
export enum CallType {
  Undefined,
  Incoming,
  Outgoing,
}

export enum OutcomeType {
  Undefined,
  Interested,
  LeftMessage,
  NoResponse,
  Notabletoreach,
  DNC,
  Pending,
  Done,
}
export const meetingType: any = {
  0: "Undefined",
  1: "Online",
  2: "Offline",
};
export const callType: any = {
  0: "Undefined",
  1: "Incoming",
  2: "Outgoing",
};

export const outcomeType: any = {
  0: "Undefined",
  1: "Interested",
  2: "Left Message",
  3: "No response",
  4: "Not able to reach",
  5: "DNC",
  6:"Pending",
  7:"Done",
};
export const responseStatus: any = {
  0: "Undefined",
  1: "Interested",
  2: "Not Interested",
  3: "DNP",
  4: "Follow Up",
};
export const CenterVisited: any = {
  0: "None",
  1: "Yes",
  2: "No",
};
export const CategoryAttachmentOptions: any = [
  { label: "All", value: 0 },
  { label: "Note", value: 1 },
  { label: "Call Log", value: 2 },
  { label: "Email", value: 3 },
  { label: "Meeting", value: 4 },
  { label: "Task", value: 5 },
  { label: "Student Documents", value: 6 },
  { label: "Email Invoice", value: 7 },
  { label: "LSBU", value: 8 },
];
export const outcomeTypeOptions: any = [
  { label: "Interested", value: 1 },
  { label: "Left Message", value: 2 },
  { label: "No response", value: 3 },
  { label: "Not able to reach", value: 4 },
  { label: "DNC", value: 5, className: "dnc-option" },
  { label: "Pending", value: 6 },
  { label: "Done", value: 7 },
];
export const meetingTypeOptions: any = [
  { label: "Online", value: 1 },
  { label: "Offline", value: 2 },
];

export enum UserLogActions {
  Undefined = 0,
  Insert = 1,
  Update = 2,
  Delete = 3,
  DeleteMany = 4,
  Approved = 5,
  EnquiryReject = 6,
  ProcessStepChanged = 7,
  EnquiryRestore = 8,
  Restore=9

}
export const CallTypeOption: any = [
  { label: "Incoming", value: 1 },
  { label: "Outgoing", value: 2 },
];

export const ProcessStepsEnumName: any = {
  1: "Interested",
  2: "New",
  3: "Counseling",
  4: "Registration",
  5: "Documents",
  6: "Email Invoice",
  7: "Verification",
  8: "CIT",
  9: "Enrolled",
};
export enum DataTypeEnum {
  Undefined,
  DateTime,
  String,
  Number,
  Boolean,
}
export const nationalityOption = [
  {
    label: "Indian",
    value: "Indian",
  },
];
export let StudyModeObj: any = {
  0: "Regular",
  1: "Private",
};
export let LevelObj: any = {
  0: "Beginner",
  1: "Intermediate",
  2: "Advanced",
};

export let languageProficiency: any = {
  0: "Beginner",
  1: "Intermediate",
  2: "Advanced",
};

export enum DateType {
  Undefined,
  EnrollDate,
}

export const processStepsOptions = [
  // { label: "Website", value: 1 },
  { label: "New", value: 2 },
  { label: "Counseling", value: 3 },
  { label: "Registration", value: 4 },
  { label: "Documents", value: 5 },
  { label: "EmailInvoice", value: 6 },
  { label: "Verification", value: 7 },
  { label: "CIT", value: 8 },
  { label: "Enrolled", value: 9 },
];

export const ResponseStatusOption = [
  // {
  //   value: 0,
  //   label: "None"
  // },
  {
    value: 1,
    label: "Interested",
  },
  {
    value: 2,
    label: "Not Interested",
  },
  {
    value: 3,
    label: "DNP",
  },
  {
    value: 4,
    label: "Follow Up",
  },
];
export const CenterVisitedOptions: any = [
  { label: "Yes", value: 1 },
  { label: "No", value: 2 },
];
export const categoryType: any = {
  0: "Undefined",
  1: "ClassSchedule",
  2: "ExamSchedule",
  3: "GeneralSchedule",
};
export const CategoryTypeOption: any = [
  { label: "ClassSchedule", value: 1 },
  // { label: "ExamSchedule", value: 2 },
  // { label: "GeneralSchedule", value: 3 },
];

export enum ScheduleCategory {
  Undefined,
  ClassSchedule,
  ExamSchedule,
  GeneralSchedule,
}

export const GradingScaleOptions: any = [
  { label: "Grades", value: "Grades" },
  { label: "Rubric", value: "Rubric" },
  { label: "Percentages", value: "Percentages" },
  { label: "ActualPointMarks", value: "ActualPointMarks" },
];

export enum RecordStatusType {
  Undefined = 0,
  Drafted = 1,
  Published = 2,
  Deleted = 3,
  Approved = 4,
  Pending = 5,
}

export const FeesType = {
  Paid: "Paid",
  Due: "DueStudent",
  DueStudentLeft: "DueStudentLeft",
};

// export enum RoleTypes {
//   undefined,
//   Employee,
//   student,
// }

export enum statusEnum {
  Undefined,
  Pending,
  Approve,
  Cancel,
  Reject,
}

export enum leaveStatusEnum {
  Pending,
  Approve,
  Cancel,
  Reject,
}
export const StatusOptions: any[] = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "inactive",
    label: "Revoked",
  },
  {
    value: "active",
    label: "Enrolled",
  },
  {
    value: "readmission",
    label: "Readmission",
  },
];
export const BioDeviceOptions:any[]=[
  {
    value:0,
    label:"All"
  },
  {
    value:1,
    label:"Access Only"
  },
  {
    value:2,
    label:"Access & Attendance"
  }
]

export const leaveStatusObject: Record<string, number> = {
  Pending: 0,
  Approve: 1,
  Cancel: 2,
  Reject: 3,
};

export const LeaveTypeEnum: any = {
  0: "Casual Leave",
  1: "Sick Leave",
};
// export const RoleTypesOptions = [
//   {
//     value: RoleTypes.Employee,
//     label: "Employee",
//   },
//   {
//     value: RoleTypes.student,
//     label: "Student",
//   },
// ];

export enum PaidByEnum
{
  CIT,
  Student
}

export const ActiveInactiveOptions: any[] = [
  {
    value: "all",
    label: "All",
  },
  {
    value: "inactive",
    label: "Inactive",
  },
  {
    value: "active",
    label: "Active",
  },
];
export enum AttandanceStatusType {
  All,
  Present,
  Absent,
  Leave,
}

export enum PeriodTypeEnum
{
  Period,
  Break
}
export enum ActionBioTypeEnum
{
  Undefined,
  AssignAccessOnly,
  AssignAccess,
  RemoveAccess,
  EnableAttSync,
  DisableAttSync
}
export enum AllowDocumentsFor {
  ForAdmin,
ForStudnetAndAdmin,
ForOfficalDocuments,
}
export enum EnquiryCounselorActionOptions  
{
  All,
  Assigned,
  NotAssigned
}

export enum EnquiryCallStatusEnum
{
  Undefined,
  Interested,
  Pending,
  NotInterested,
  FollowUp,
  NotCalled
}

export enum ClassStatus
{
  Passed,
  Pursuing
}
export enum HdfcOrderStatus
{
  Undefined,
  Pending,
  Success,
  Failed,
  InProgress,
}
 
export enum PaymentType
{
    Undefined,
    Enrollment, 
    Admission,  
    University
}

export const PaymentTypeWebOptions:any[]=[
  {
    value:PaymentType.Undefined,
    label:"None"
  },
  {
    value:PaymentType.Enrollment,
    label:"Enrollment"
  },
  {
    value:PaymentType.Admission,
    label:"Admission"
  },
  {
    value:PaymentType.University,
    label:"University"
  }
]

export enum UserType
{
  All,
  Employee,
  Student,
}

export enum QuestionsType {
  Undefined, //default for question Type
  MCQ, // MCQ for radio option
  LongAnswer, //For textBox
  Program, //For Programming languages
}

export const QuestionsTypeOptions: any[] = [
  // {
  //   value: QuestionsType.Undefined,
  //   label: "None",
  // },
  {
    value: QuestionsType.MCQ,
    label: "MCQ",
  },
  {
    value: QuestionsType.LongAnswer,
    label: "Long Answer",
  },
  {
    value: QuestionsType.Program,
    label: "Program",
  },
];

export enum MarksStatus
{
    Undefined, 
    Pending,
    Marked, 
}
export const JDoodleLanguage: {
  label: string;
  value: string;
  versionIndex: string;
  isFrontEnd?: boolean;
}[] = [
  { label: "Python", value: "python3", versionIndex: "3" },
  { label: "Java", value: "java",versionIndex: "5" },
  { label: "C++", value: "cpp",versionIndex:"6" },
  { label: "Node js", value: "nodejs",versionIndex:"6" },
  { label: "PHP", value: "php",versionIndex:"3" },
  // { label: "MySql", value: "mysql",versionIndex:"0" },
  // { label: "SQL", value: "sql",versionIndex:"5" },
  { label:"HTML/CSS/JavaScript", value:"HTML/CSS/JavaScript",versionIndex:"",isFrontEnd:true },
]

export enum ModelType {
  noOpenModel = 0,
  note = 1,
  callLog = 2,
  mail = 3,
  meeting = 4,
  task = 5,
  email = 6,
  registrationFees = 7,
  rejection = 8,
  acknowledgement = 9,
  verifyDocument = 10,
  lsbuAddCV = 11,
  lsbuAddReceivedStudyContact = 12,
  lsbuReceivedCredentials = 13,
  credentials = 14,
  restore = 15,
}